// @ts-nocheck
import { FunctionComponent, useEffect, useState } from "react";
import { Layout } from "antd";
import { DataType } from "../../types/listUsers";
import "./page-builder-view.scss";
import parse, { domToReact } from 'html-react-parser';
import TitleComponent from "../../components/page-builder/TitleComponent";
import { isEmpty } from "lodash";
const { Content } = Layout;
import { useParams } from 'react-router-dom';
var indexDB = require('idbcache').default;
import ContactComponent from "../../components/page-builder/ContactComponents";
import LinkedCourseComponent from "../../components/page-builder/LinkedCourseComponent";
import HeaderGeneralIntroduction from "../../components/portal-adminstration/general-introduction/HeaderGeneralIntroduction";
import { LecturerBlockCustom } from "./components/lecturer-block";
import { ConditionBlockCustom } from "./components/condition-block";
import { getIdIndexDB } from "./grapesjs-service";
import { getTemplateByCourseId } from "../../service/page-builder/page-builder";
import { renderTemplate } from "./renderTemplate";

type ProfileInfoProps = {
	dataUser?: DataType;
};

const PageBuilderView: FunctionComponent<ProfileInfoProps> = () => {
const [html, setHTML] = useState<string>('');
	const params = useParams();
	useEffect(() => {
		const fetchTemplate = async () => {
			try {
				const res = await getTemplateByCourseId(params?.id)
				setHTML(res?.data.data.template)
			} catch (error) {

			}
		}
		fetchTemplate()
	}, [params?.id])


	return (
		<>
			{!isEmpty(html) ? renderTemplate(html, true) : null}

			{/* {
				!isEmpty(html) ? <Content className="page-builder-view">
					{
						parse(html, {
							replace(domNode) {
								if ((domNode as Element).attribs && domNode.attribs['advanced-setting-display-subject'] === 'hidden') {
									return <></>;
								}

								if ((domNode as Element).attribs && domNode.attribs['component-class']) {
									switch ((domNode as Element).attribs['component-class']) {
										case 'TitleComponent': {
											const props = domNode.attribs;
											return <TitleComponent {...props}>
												{domToReact((domNode as Element).children)}
											</TitleComponent>;
										}
										case 'LecturerBlockCustom': {
											const props = domNode.attribs;
											return <LecturerBlockCustom {...props}>
												{domToReact((domNode as Element).children)}
											</LecturerBlockCustom>;
										}
										// case 'ContactComponent': {
										//     const props = domNode.attribs;
										//     return <ContactComponent {...props}>
										//         {domToReact((domNode as Element).children)}
										//     </ContactComponent>;
										// }
										// case 'LinkedCourseComponent': {
										//     const props = domNode.attribs;
										//     return <LinkedCourseComponent {...props}>
										//         {domToReact((domNode as Element).children)}
										//     </LinkedCourseComponent>;
										// }
										case 'HeaderGeneralIntroduction': {
											const props = domNode.attribs;
											return <HeaderGeneralIntroduction {...props}>
												{domToReact((domNode as Element).children)}
											</HeaderGeneralIntroduction>;
										}
										case 'ConditionBlockCustom': {
											const props = domNode.attribs;
											return <ConditionBlockCustom {...props}>
												{domToReact((domNode as Element).children)}
											</ConditionBlockCustom>;
										}
									}
								}
							},
						})
					}
				</Content> : null
			} */}
		</>

	);
};

export default PageBuilderView;

